import { AccordionTab } from 'primereact/accordion';

const BaseAccordionTab = AccordionTab

export default BaseAccordionTab;